const defaultEpoch = new Date(2016, 1, 1);

export default class Snowflake {
  constructor(nodeID, epoch) {
    this.nodeID = nodeID || (Math.floor(Math.random() * 0x400));
    this.epoch = epoch || defaultEpoch;
    this.seq = 0;
    this.lastTime = 0;
  }

  /* eslint-disable no-bitwise */
  id() {
    const t = new Date() - this.epoch;
    if (t <= this.lastTime) {
      this.seq = this.seq + 1;
      if (this.seq === 4096) {
        this.seq = 0;
        this.lastTime = this.lastTime + 1;
      }
    } else {
      this.seq = 0;
      this.lastTime = t;
    }
    const hi = ((t >> 10) & 0xffffffff) >>> 0;
    const lo = (((t & 0x3ff) << 22) | ((this.seq & 0xfff) << 10) | (this.nodeID & 0x3ff)) >>> 0;
    let s = '';
    let rem = lo;
    for (let i = 0; i < 9; i += 1) {
      s = (rem % 10).toString() + s;
      rem = (rem / 10) | 0;
    }
    rem = hi + rem;
    while (rem > 0) {
      s = (rem % 10).toString() + s;
      rem = (rem / 10) | 0;
    }
    return s;
  }
  /* eslint-enable no-bitwise */
}
